module.exports = __webpack_public_path__ + "media/shape/shape-189-be2778b1.png";